import { render, staticRenderFns } from "./ResendConfirmCodePage.vue?vue&type=template&id=12fc302a&scoped=true"
import script from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
export * from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
import style0 from "./ResendConfirmCodePage.vue?vue&type=style&index=0&id=12fc302a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc302a",
  null
  
)

export default component.exports